import Question from '@/models/question';
import QuestionResult from '@/models/question_result';
import axios from 'axios'
import Result from '../models/result';
import BasicUtil from './basicUtil'
import shiken3 from './shiken3'
import ronten3 from './ronten3';
import shiken2 from './shiken2'
import ronten2 from './ronten2';
import Category from '@/models/category';

export default class HttpClient {

  private apiEndpoint: string = process.env.VUE_APP_API

  public async saveResult(data: Result[]): Promise<void> {
    return axios.post(this.apiEndpoint + "/app",
      data,
      {
        headers: {
          sc: BasicUtil.getSc(),
        }
      })
  }

  public getShiken(grade: number): any {
    if (grade == 3) {
      return JSON.parse(JSON.stringify(shiken3))
    } else if (grade == 2) {
      return JSON.parse(JSON.stringify(shiken2))
    }
    return JSON.parse(JSON.stringify(shiken3))
  }

  public getRonten(grade: number): Category[] {
    if (grade == 3) {
      return ronten3 as Category[]
    } else if (grade == 2) {
      return ronten2 as Category[]
    }
    return []
  }

  public getRandom15(grade: number): Question[] {
    const shiken = this.getShiken(grade)
    let questions = shiken.questions
    const shuffle = ([...array]) => {
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }
    questions = shuffle(questions).slice(0, 15)

    const categories = this.getRonten(grade)
    questions.forEach((q: Question) => {
      q.questionResult = new QuestionResult()
      q.questionResult.questionId = q.id ? Number(q.id) : 1
      const category = categories.find(c => {
        return c.id == q.categoryId
      })
      if (category != undefined) {
        q.category = category
      }
    })

    return questions
  }

  public getRontenQuestions(grade: number, categoryId: number): Question[] {
    const shiken = this.getShiken(grade)
    let questions: Question[] = shiken.questions
    questions = questions.filter(q => {
      return q.categoryId == categoryId
    })
    const categories = this.getRonten(grade)
    const category = categories.find(c => {
      return c.id == categoryId
    })
    if (category != undefined) {
      questions.forEach(q => {
        q.questionResult = new QuestionResult()
        q.questionResult.questionId = q.id ? Number(q.id) : 1
        q.category = category
      })
    }
    return questions
  }

  public getQuestionFromId(grade: number, id: number) {
    const shiken = this.getShiken(grade)
    const categories = this.getRonten(grade)
    let questions: Question[] = shiken.questions
    const question = questions.find(q => {
      return q.id == id
    })
    if (question == undefined) return null
    question!.category = categories.find(c => {
      return c.id == question?.categoryId
    })
    return question
  }
}